module.exports = __webpack_public_path__ + "img/authentication-bg.d0231355.svg";